import { writable } from 'svelte/store';

export const loadedWorkouts = writable<any>({});
